import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import css from './social.css'

const Social = ({ links, isCompact }) => (
    <div className={isCompact ? css.socialSmall : css.social}>
        {!isCompact && <p className={css.followLabel}>Follow on:</p>}
        {links.map(({ type, url }) => (
            <a key={type} className={css[`${type}Button`]} href={url} target="_blank" />
        ))}
    </div>
)

Social.propTypes = {
    links: PropTypes.array.isRequired,
    isCompact: PropTypes.bool,
}

export default Social
